<template>
  <div role="button" tabindex="0" @click="onButtonClick($event)" 
   @keydown.enter.space.prevent="onButtonClick"
  class="usa-link border-base-lightest border-2px display-flex flex-column height-full minh-15 padding-x-2 padding-y-3 radius-md shadow-1 text-center text-no-underline hover:text-underline">
     <span class="svg-lg text-black" v-html="data.fields.cardsvg"></span>
    <div class="text-bold card-link" >
      <rich-text-renderer :data="data.fields.cardBody"></rich-text-renderer>
    </div>
  </div>
</template>
<script>
import { urlCountryCode } from "@/helpers/url";
import { getCountryName } from "@/store/api";
import { getDataByFieldSlug } from "@/store/api";

function onButtonClick(event) {
  this.additionaldata.faqSection.$emit(
    "show-question",
    this.data.fields.cardSlug,
    this.$parent
  );
  this.additionaldata.faqSection.$emit('card-click');
  var elmnt = document.getElementById("faq-search-results-count");
  if(elmnt) elmnt.scrollIntoView({ behavior: "smooth", block: "start" });
}
export default {
  name: "faq-card",
  props: ["data", "additionaldata"],
  data() {
    return {
      StyleClass: "",
      countryCode: "",
      country: "",
      dataLoaded: false,
      cgiDataLoaded: false,
        pageData: {},
        cgiData: {}
    };
  },
  methods: {
    onButtonClick: onButtonClick,
  },
  created() {
    this.countryCode = urlCountryCode();
    getCountryName(this.countryCode).then((country) => {
        this.country = country;
    });
    getDataByFieldSlug("blockOfText", "faq-icons", "global").then((pageData) => {
        this.dataLoaded = true;
        if (!pageData) {
          console.log('404');
        }
        this.pageData = pageData;
      });

  }
};

</script>



<style scoped lang="scss">
  .footer-text {
    .rich-text {
      ::v-deep p { 
        font-size: 0.86507rem; 
      }
    }
  }
</style>


<style lang="scss" scoped>
.usa-link:hover {
  color: #0071BC;
  display: block;
}

.card-link {
  cursor: pointer;
  ::v-deep span {
    display: flex;
    width: auto;
    justify-content: center;
    height: auto;
  }
  ::v-deep p {
    margin: 0;
    a {
      text-decoration: none;
    }
  }
}

</style>